/**
 * Created by Ning Jiang on 2022-04-01.
 */

import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";

export class BelowStakeWinRestriction {

    private static getBasePlayedBetValue(payedBetValue:number):number {
        let betLevel = SlotGame.api.freeBets.hasFreeBets() ? SlotGame.api.freeBets.getBet() : SlotGame.api.betLevel.getLevel();
        return payedBetValue || parseFloat(betLevel);
    }

    public static getBuyFeaturePrice(payedBetValue:number):number {
        const activeBetFeature = SlotGame.api.betFeatureController.getActiveBetFeature();
        if(activeBetFeature) {
            return activeBetFeature.getTotalCost();
        }
        return BelowStakeWinRestriction.getBasePlayedBetValue(payedBetValue);
    }

    // https://github.com/nolimitcity/nolimit-slot-launcher/issues/397
    public static isWinBelowStake(accumulatedRoundWin:number, payedBetValue:number):boolean {
        return SlotGame.api.gameClientConfiguration.belowStakeWinRestriction && (accumulatedRoundWin <= this.getBuyFeaturePrice(payedBetValue));
    }

    public static isWinBelowPlayedBetValue(accumulatedRoundWin:number, payedBetValue:number):boolean {
        if(!SlotGame.api.gameClientConfiguration.belowStakeWinRestriction) {
            return false;
        }

        // const activeBetFeature = SlotGame.api.betFeatureController.getActiveBetFeature();
        // const price = activeBetFeature && XBetController.boostedNames.includes(activeBetFeature.name) ? activeBetFeature.getTotalCost() : BelowStakeWinRestriction.getBasePlayedBetValue(payedBetValue);
        const price = BelowStakeWinRestriction.getBasePlayedBetValue(payedBetValue);

        return accumulatedRoundWin <= price;
    }
}